<template>
  <v-form>
      <v-container :key="reloadPage">
        <v-row>
          <v-col cols="12">
            <h1>Theme options</h1>
            <p>
              Customize your theme.
            </p>
            <p class="caption">
              Always use 6 characters when setting 'hex' color code. Use only hex code (#ffffff) to set colors.
            </p>
            <v-divider></v-divider>
          </v-col>
          <v-col :class="{ 'grey lighten-5': i % 2 === 0, 'white': i % 2 !== 0 }" :key="key" v-for="(key, i) in getThemeType.themeObjNames" cols="12" sm="6">
            <h4>{{ `${key[0].toUpperCase()}${key.slice(1)}` }}</h4>
            <div style="position:relative" :key="prop" v-for="prop in Object.keys(getThemeType.getAllItems[key])">
              <v-text-field
                @change="val => setNewTheme(val, key, prop)"
                :label="prop"
                :value="getThemeType.getAllItems[key][prop]"
                filled
                shaped
              ></v-text-field>
              <div
                v-if="hexColorCheck(getThemeType.getAllItems[key][prop])"
                class="color-palette"
                :style="{background: getThemeType.getAllItems[key][prop]}"
                @click="changeColor(key + prop + getThemeType.getAllItems[key][prop])"
              >
                <chrome-picker
                  v-if="(key + prop + getThemeType.getAllItems[key][prop] === currentColor) && showColorEditor"
                  :value="getThemeType.getAllItems[key][prop]"
                  @input="val => updateColor(val, key, prop)"
                ></chrome-picker>
              </div>
            </div>
        </v-col>

      </v-row>
    </v-container>
  </v-form>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { isHexColor } from '@/utils/helpers'
import { Chrome } from 'vue-color'
import { theInitialTheme } from '@/utils/setInitialTheme'

export default {
  name: 'Footer',
  components: {
    'chrome-picker': Chrome
  },
  data: () => ({
    msg: null,
    themeObjNames: [],
    currentColor: null,
    showColorEditor: false,
    reloadPage: 0,
    colorEditor: null
  }),
  watch: {
    reloadCashier () {
      this.reloadPage++
    }
  },
  methods: {
    ...mapActions([
      'overwriteTheme'
    ]),
    changeColor (color) {
      this.colorEditor && this.colorEditor.length === 3 && this.setNewTheme(...this.colorEditor, 'update')
      this.currentColor = color
      this.showColorEditor = !this.showColorEditor
      this.colorEditor = null
    },
    updateColor (value, key, prop) {
      this.colorEditor = [value.hex, key, prop]
    },
    setNewTheme (value, key, prop, update) {
      const newTheme = this.fullTheme
      newTheme[key][prop] = value
      this.overwriteTheme(newTheme)
    },
    hexColorCheck (value) {
      return isHexColor(value)
    }
  },
  computed: {
    ...mapState({
      reloadCashier: ({ config }) => config.reloadCashier,
      theme: ({ theme }) => theme.theme
    }),
    fullTheme () {
      const initialTheme = theInitialTheme()
      const theme = this.theme
      const newTheme = {
        ...initialTheme
      }
      for (let prop in theme) {
        for (let innerProp in theme[prop]) {
          newTheme[prop][innerProp] = theme[prop][innerProp]
        }
      }
      return newTheme
    },
    getThemeType () {
      const initial = this.fullTheme
      const getAllItems = {}
      const themeObjNames = []
      for (let prop in initial) {
        themeObjNames.push(prop)
        getAllItems[prop] = initial[prop]
      }
      return {
        themeObjNames,
        getAllItems
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.v-input__slot {
  position: relative;
}
.color-palette {
  position: absolute;
  bottom: 30px;
  right: 0;
  height: 30px;
  width: 40px;
  background: red;
  z-index: 10;
  cursor: pointer;
  border: 1px solid black;
}
h4 {
  color: rgb(20 107 92);
}
</style>
